import cn from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

const ArrowLeftIcon = ({ className }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24' height='24'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    className={cn('feather', 'feather-arrow-left', className)}
  >
    <line x1='19' y1='12' x2='5' y2='12' />
    <polyline points='12 19 5 12 12 5' />
  </svg>
)

ArrowLeftIcon.propTypes = {
  className: PropTypes.string
}

const ArrowRightIcon = ({ className }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24' height='24'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    className={cn('feather', 'feather-arrow-right', className)}
  >
    <line x1='5' y1='12' x2='19' y2='12' />
    <polyline points='12 5 19 12 12 19' />
  </svg>
)

ArrowRightIcon.propTypes = {
  className: PropTypes.string
}

export { ArrowLeftIcon, ArrowRightIcon }
